// Tooltip.jsx
import React from "react";

const Tooltip = ({ text, children }) => {
  return (
    <div className="group relative flex items-center justify-center w-full">
      {children}
      <div className="absolute top-1/2 left-full -translate-y-1/2 ml-2 z-50 w-max max-w-xs px-2 py-1 overflow-visible rounded bg-black text-white text-xs shadow-lg opacity-0 group-hover:opacity-100 transition duration-200">
        {text}
        <div className="absolute left-[-6px] top-1/2 -translate-y-1/2 w-0 h-0 border-y-4 border-y-transparent border-r-8 border-r-black" />
      </div>
    </div>
  );
};

export default Tooltip;
